import { observer } from 'mobx-react';
import { ComponentProps } from 'react';
import Modal from '.';
import WithOpenableLogic from './WithOpenableLogic';

type AsModalProps = ComponentProps<typeof WithOpenableLogic> & ComponentProps<typeof Modal>;

function AsModal({ state, close, title, children, dimensions, placement }: AsModalProps) {
  return (
    <WithOpenableLogic state={state}>
      <Modal close={close} title={title} dimensions={dimensions} placement={placement}>
        {children}
      </Modal>
    </WithOpenableLogic>
  );
}

export default observer(AsModal);
